export default {
  common: {
    pleaseEnterSearchKeywords: "Veuillez entrer des mots-clés de recherche"
  },
  outputProjectList: {
    dateofRegistration: "Date d'inscription",
    updateDate: "heure de mise à jour",
    projectName: "Nom du projet",
    dateofAudit: "Date d'audit (année-mois)",
    customerName: "Nom du client",
    customerEmail: "Courriel du client",
    address: "Adresse",
    zone: "Zone",
    city: "Ville",
    submiter: "Envoyeur",
    projectStatus: "Statut du projet",
    estimateEcmQutedAmount: "Montant estimatif de la cotation ECM (USD)",
    expectedOrder: "Commande attendue (mois/année)",
    actualEcmQutedAmount: "Montant réel de la cotation ECM (USD)",
    actualOrder: "Ordre réelle (mois/année)",
    winProbability: "Probabilité de gagner",
    statusRemarks: "remarques",
    lastUpdateDate: "Dernière date de mise à jour"
  },
  outputAccountList: {
    activate: "Activer",
    registerDate: "Date d'enregistrement",
    lastLoginDate: "Dernière date de connexion"
  },
  nomenclature: {
    row0_1: "Terme",
    row0_2: "Définition",
    row1_1: "AC",
    row1_2: "Air-cooled; signifie refroidi par air.",
    row2_1: "AHRI",
    row2_2:
      "Abréviation de Air-Conditioning, Heating, and Refrigeration Institute; organisme sectoriel américain qui certifie les performances des groupes frigorifiques utilisées dans les sélections eCAT.",
    row3_1: "Groupe frigorifique à air",
    row3_2: "Groupe frigorifique qui rejette la chaleur directement dans l’air ambiant via des ventilateurs de condenseur et ne nécessite ni tour de refroidissement ni pompe à eau de condenseur.",
    row4_1: "Température d’approche",
    row4_2:
      "Différence de température entre la température de sortie d’eau de la tour de refroidissement et la température de bulbe humide à l’entrée; valeur par défaut 3 °C dans iECM et paramètre clé pour la modélisation de l’eau de condenseur.",
    row5_1: "ASIA",
    row5_2: "Portefeuille régional Asie. Portefeuille de fabrication utilisé pour les groupes frigorifiques Carrier principalement commercialisés en Asie.",
    row6_1: "Référence",
    row6_2: "Système frigorifique existant utilisé comme référence de comparaison.",
    row7_1: "Type de bâtiment",
    row7_2: "Classification du type de bâtiment sélectionnée lors de la configuration du projet, par exemple bureau, hôtel, hôpital ou autres; elle peut influencer les hypothèses par défaut.",
    row8_1: "CAPEX",
    row8_2: "Capital expenditure; coût d’investissement initial du projet de retrofit.",
    row9_1: "Intensité carbone de l’électricité",
    row9_2:
      "Masse de CO₂ équivalent émise par unité d’électricité consommée; la valeur par défaut dans iECM est de 0.707 kgCO₂e/kWh, bien qu’elle varie selon la région et le mix énergétique du réseau.",
    row10_1: "Groupe frigorifique centrifuge",
    row10_2:
      'Type de groupe frigorifique utilisant un compresseur centrifuge et couramment employé dans les applications commerciales et industrielles de grande taille; il est désigné par "WC–Centri" dans iECM.',
    row11_1: "Eau glacée",
    row11_2: "Eau refroidie par le groupe frigorifique et circulant dans le système de traitement d’air du bâtiment afin d’assurer le refroidissement des locaux.",
    row12_1: "CHW",
    row12_2: "Chilled water; signifie eau glacée.",
    row13_1: "CHWP",
    row13_2: "Chilled water pump; signifie pompe d’eau glacée.",
    row14_1: "Cluster",
    row14_2: "Groupe de mois présentant des conditions d’exploitation ou météorologiques similaires et utilisé dans la simulation.",
    row15_1: "Refroidissement de confort",
    row15_2: "Refroidissement destiné à assurer le confort thermique des occupants dans les bâtiments, comme les bureaux et les hôtels; il se distingue du refroidissement de procédé.",
    row16_1: "Collecteur commun",
    row16_2:
      "Configuration de tuyauterie d’eau de condenseur dans laquelle tous les groupes frigorifiques partagent un collecteur unique d’alimentation et de retour, permettant à n’importe quelle tour de refroidissement de desservir n’importe quel groupe frigorifique.",
    row17_1: "Eau de condenseur",
    row17_2: "Eau circulant entre le condenseur du groupe frigorifique et la tour de refroidissement afin de rejeter la chaleur du cycle frigorifique.",
    row18_1: "COP",
    row18_2: "Coefficient of performance; signifie coefficient de performance.",
    row19_1: "CT",
    row19_2: "Cooling tower; signifie tour de refroidissement.",
    row20_1: "CWP",
    row20_2: "Condenser water pump; signifie pompe à eau de condenseur.",
    row21_1: "CWS",
    row21_2: "Condenser water supply; signifie alimentation en eau de condenseur.",
    row22_1: "DB",
    row22_2: "Electrical distribution board; signifie tableau de distribution électrique.",
    row23_1: "Taux de dégradation",
    row23_2:
      "Diminution annuelle en pourcentage de l’efficacité du groupe frigorifique due au vieillissement, à l’encrassement et à l’usure; les hypothèses typiques sont de 0.25 % pour Bon, 0.50 % pour Moyen, 0.75 % pour Inférieur à la moyenne et 1.00 % pour Mauvais.",
    row24_1: "Digital e-CAT",
    row24_2: "Outil de modélisation fondé sur la physique et les données, permettant de prédire les performances des groupes frigorifiques.",
    row25_1: "Taux d’actualisation",
    row25_2: "Taux d’intérêt utilisé pour calculer la valeur actuelle des flux de trésorerie futurs dans l’analyse NPV; la valeur par défaut dans iECM est de 3 %.",
    row26_1: "Température de bulbe sec",
    row26_2:
      "Température de l’air ambiant mesurée à l’aide d’un thermomètre standard, non affectée par l’humidité; elle est utilisée dans iECM pour les profils météorologiques liés à la modélisation des groupes frigorifiques à air et aux paramètres de cluster.",
    row27_1: "Bibliothèque e-CAT",
    row27_2: "Base de données officielle des groupes frigorifiques Carrier e-CAT accessible à tous les utilisateurs.",
    row28_1: "EA",
    row28_2: "Energy audit; signifie audit énergétique.",
    row29_1: "EA Report",
    row29_2: "Energy Audit Report; rapport de baseline généré à la fin de l’étape d’aperçu de la baseline, documentant les performances actuelles du système et les possibilités d’amélioration.",
    row30_1: "eCAT",
    row30_2: "Catalogue électronique Carrier et logiciel de sélection de groupes frigorifiques.",
    row31_1: "ECM",
    row31_2: "Energy Conservation Measure; action proposée d’amélioration de l’efficacité.",
    row32_1: "ECM Report",
    row32_2: "Energy Conservation Measure Report; document de proposition contenant la solution recommandée, les économies d’énergie, l’analyse financière et l’argumentaire économique.",
    row33_1: "EER",
    row33_2: "Energy efficiency ratio; signifie ratio d’efficacité énergétique.",
    row34_1: "EMEA",
    row34_2: "Europe, Moyen-Orient et Afrique. Portefeuille de fabrication utilisé pour les groupes frigorifiques Carrier commercialisés en Europe, au Moyen-Orient et en Afrique.",
    row35_1: "Escalation Rate",
    row35_2: "Augmentation annuelle en pourcentage supposée des coûts d’exploitation tels que l’énergie, la maintenance, les réparations et autres; la valeur par défaut dans iECM est de 2 % par an.",
    row36_1: "e-CAT estimé",
    row36_2: "Données de performance estimées par l’algorithme Digital e-CAT lorsque les données e-CAT standard ne sont pas disponibles.",
    row37_1: "FX rate",
    row37_2: "Foreign exchange rate; signifie taux de change.",
    row38_1: "Hz",
    row38_2: "Hertz — unité de fréquence; utilisée dans iECM pour définir les limites de fonctionnement des VFD des pompes et des ventilateurs de tour de refroidissement.",
    row39_1: "iECM",
    row39_2: "Intelligent Energy Conservation Measure; outil Carrier d’audit énergétique et d’analyse de retrofit pour l’optimisation des centrales d’eau glacée.",
    row40_1: "Incentives & Rebates",
    row40_2: "Incitations financières gouvernementales ou des services publics prises en compte dans le calcul du NPV, année par année, pendant une durée pouvant aller jusqu’à 19 ans.",
    row41_1: "kgCO₂e",
    row41_2: "Kilogrammes de dioxyde de carbone équivalent — unité utilisée pour exprimer les émissions de gaz à effet de serre associées à la consommation d’électricité.",
    row42_1: "kW",
    row42_2: "Kilowatt — unité de puissance électrique égale à 1 000 watts.",
    row43_1: "kWc",
    row43_2: "Kilowatt cooling — puissance frigorifique délivrée par un groupe frigorifique ou une installation, exprimée en kilowatts.",
    row44_1: "kWe",
    row44_2: "Input kilowatt electrical — puissance électrique consommée par un groupe frigorifique ou un composant de l’installation.",
    row45_1: "kWh",
    row45_2: "Kilowatt-heure — unité d’énergie correspondant à 1 kW soutenu pendant 1 heure.",
    row46_1: "kWh/RTh",
    row46_2: "Kilowatt-heures par tonne de réfrigération-heure; indicateur d’efficacité de l’installation.",
    row47_1: "Région/source de fabrication",
    row47_2:
      "Portefeuille régional de fabrication Carrier utilisé pour déterminer la bibliothèque de modèles de groupes frigorifiques prise en charge (ASIA, EMEA ou NAO). Une même famille de groupes frigorifiques peut être disponible dans plusieurs régions.",
    row48_1: "Saisie multipoint",
    row48_2: "Fonction de saisie de données dans iECM qui copie la valeur du mois en cours vers tous les mois suivants, accélérant la saisie répétitive sans écraser les valeurs déjà saisies.",
    row49_1: "NAO",
    row49_2: "North America Operations. Portefeuille de fabrication utilisé pour les groupes frigorifiques Carrier commercialisés via North America Operations.",
    row50_1: "NPV",
    row50_2: "Net Present Value; valeur actuelle des flux de trésorerie futurs du projet.",
    row51_1: "Heures creuses",
    row51_2: "Température moyenne mensuelle globale. Représente la partie moyenne de la journée — utilisée pour pondérer l’allocation de la période creuse nocturne.",
    row52_1: "Période de fonctionnement",
    row52_2: "Classification du type de jour utilisée dans la modélisation mensuelle de la baseline — jour ouvré, week-end ou période complète — afin de refléter différents profils d’utilisation.",
    row53_1: "Groupe frigorifique du site en fonctionnement",
    row53_2:
      "Groupe frigorifique du site sélectionné pour représenter le groupe principal fonctionnant pendant une période de charge spécifique (par exemple peak ou off-peak). Le groupe sélectionné sert d’équipement de référence pour la modélisation des performances de baseline et la sélection du groupe proxy.",
    row54_1: "Bibliothèque personnalisée",
    row54_2: "Bibliothèque personnelle contenant des données de groupes frigorifiques importées ou gérées par l’utilisateur.",
    row55_1: "Charge partielle",
    row55_2: "Fonctionnement en dessous de la capacité nominale totale.",
    row56_1: "Période de retour sur investissement",
    row56_2: "Nombre d’années nécessaires pour que les économies annuelles cumulées soient égales à l’investissement total en CAPEX.",
    row57_1: "Pointe",
    row57_2: "Moyenne des températures maximales quotidiennes par mois. Représente la partie la plus chaude de la journée — utilisée pour pondérer l’allocation de la période peak diurne.",
    row58_1: "Pointe / Heures creuses dans le tarif",
    row58_2: "Périodes de tarification de l’électricité selon l’heure d’utilisation, dans lesquelles les heures de pointe ont des tarifs plus élevés et les heures creuses des tarifs plus faibles.",
    row59_1: "Système de contrôle de l’installation",
    row59_2:
      "Infrastructure d’automatisation et de contrôle, comprenant capteurs, contrôleurs et intégration BMS, utilisée pour optimiser le fonctionnement de la centrale d’eau glacée proposée; elle est incluse comme poste CAPEX.",
    row60_1: "PLR",
    row60_2: "Part load ratio; signifie taux de charge partielle.",
    row61_1: "Système primaire",
    row61_2: "Configuration de tuyauterie d’eau glacée dans laquelle un seul jeu de pompes fait circuler l’eau à travers les groupes frigorifiques et la boucle de distribution du bâtiment.",
    row62_1: "Système primaire–secondaire",
    row62_2:
      "Configuration de tuyauterie d’eau glacée avec des jeux de pompes séparés: les pompes primaires desservent les groupes frigorifiques, tandis que les pompes secondaires desservent la boucle de distribution du bâtiment, permettant un contrôle indépendant du débit.",
    row63_1: "Refroidissement de procédé",
    row63_2:
      "Refroidissement fourni pour des procédés industriels ou manufacturiers, tels que les centres de données ou la production pharmaceutique; il nécessite la méthode de baseline Energy Consumption dans iECM.",
    row64_1: "Proposée",
    row64_2: "Nouvelle solution recommandée évaluée par rapport à la baseline.",
    row65_1: "Groupe frigorifique proxy",
    row65_2: "Modèle de groupe frigorifique Carrier sélectionné dans la bibliothèque e-CAT pour représenter l’Operating Site Chiller lors de l’estimation et de la calibration des performances.",
    row66_1: "Reconfigurer",
    row66_2:
      "Fonction d’iECM permettant aux utilisateurs de remplacer manuellement l’algorithme automatique de sélection des groupes frigorifiques et d’affecter des groupes spécifiques à des périodes de fonctionnement spécifiques dans une solution de retrofit.",
    row67_1: "Groupe frigorifique de référence",
    row67_2:
      "Groupe frigorifique sélectionné comme référence de performance pour un modèle de baseline donné; tous les calculs de puissance, de charge frigorifique et de dégradation de cette baseline sont dérivés de ses spécifications.",
    row68_1: "Retrofit",
    row68_2:
      "Processus consistant à moderniser ou remplacer les équipements existants d’une centrale d’eau glacée par des technologies plus récentes et plus efficaces afin de réduire la consommation d’énergie et les coûts d’exploitation.",
    row69_1: "ROI",
    row69_2: "Return on investment; économies annuelles en pourcentage de l’investissement total.",
    row70_1: "RT",
    row70_2: "Refrigeration ton; unité de puissance frigorifique.",
    row71_1: "RTh",
    row71_2: "Refrigeration ton-hour; unité d’énergie frigorifique.",
    row72_1: "Tarif d’électricité",
    row72_2: "Prix de l’électricité facturé par le fournisseur par kWh; il est saisi séparément pour les périodes peak et off-peak dans la configuration de baseline.",
    row73_1: "VFD",
    row73_2: "Variable Frequency Drive; dispositif qui ajuste la vitesse du moteur en fonction de la charge.",
    row74_1: "Groupe frigorifique à eau",
    row74_2:
      "Groupe frigorifique qui rejette la chaleur via une boucle d’eau de condenseur reliée à des tours de refroidissement et qui est généralement plus efficace qu’un groupe frigorifique à air à pleine charge.",
    row75_1: "WC",
    row75_2: "Water-cooled; signifie refroidi par eau."
  }
}



// WEBPACK FOOTER //
// ./src/locale/outputFile/fr.js